import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenInventoryPageBreadcrumbs } from '@/pages/Inventory/config';
import { NavigateFunction } from 'react-router-dom';

export const requestsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenInventoryPageBreadcrumbs(navigate),
  { label: 'Solicitudes', onClick: () => navigate('/inventory/requests') },
];

